/**
 * @fileoverview PATCH handler for the "/apps/user_info/update_scheduled_merge_duplicate_users_rules" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoUpdateScheduledMergeDuplicateUsersRulesCacheKeys } from "./constants";
import type {
  AppsUserInfoUpdateScheduledMergeDuplicateUsersRulesResult,
  PatchUpdateScheduledMergeDuplicateUsersRulesProps,
} from "./types";

export const patchAppsUserInfoUpdateScheduledMergeDuplicateUsersRules = reactQueryMutationAdapter(
  appsUserInfoUpdateScheduledMergeDuplicateUsersRulesCacheKeys,
  (
    props: PatchUpdateScheduledMergeDuplicateUsersRulesProps
  ): Promise<AppsUserInfoUpdateScheduledMergeDuplicateUsersRulesResult> => {
    return fetch("/apps/user_info/update_scheduled_merge_duplicate_users_rules", "PATCH", {
      identifier: props.identifier,
      sort_order: props.sort_order,
      tiebreaker_field: props.tiebreaker_field,
      is_active: props.is_active,
    });
  }
);
